import { render, staticRenderFns } from "./Homework.vue?vue&type=template&id=6eb45044&scoped=true&"
import script from "./Homework.vue?vue&type=script&lang=js&"
export * from "./Homework.vue?vue&type=script&lang=js&"
import style0 from "./Homework.vue?vue&type=style&index=0&id=6eb45044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb45044",
  null
  
)

export default component.exports